import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { ROUTES } from "~/utils/routing/routeUtils";
import { queryTourTarget } from "../utils/queryTourTarget";

const getBuildingIdFromPath = (): string | null => {
  const segments = window.location.pathname.split("/").filter(Boolean);
  if (segments.length === 2 && segments[0] === "building") {
    return segments[1];
  }
  return null;
};

/**
 * Setup walkthrough: Building Details → Add Unit (before unit is created).
 */
export const buildingDetailsSetupTour = (t: TFunction): TourStep[] => {
  const buildingID = getBuildingIdFromPath();
  const addUnitPath = buildingID
    ? `${ROUTES.addUnit}?buildingID=${buildingID}`
    : ROUTES.addUnit;

  return [
    {
      title: t("Tour_Setup_BuildingDetails_Title"),
      description: t("Tour_Setup_BuildingDetails_Description"),
      target: () => queryTourTarget("building-details-header"),
      placement: "bottom",
    },
    {
      title: t("Tour_Setup_BuildingDetails_AddUnit_Title"),
      description: t("Tour_Setup_BuildingDetails_AddUnit_Description"),
      target: () => queryTourTarget("building-add-unit"),
      placement: "left",
      recommendedTours: [
        {
          label: t("Tour_Setup_Next_AddUnit"),
          path: addUnitPath,
        },
      ],
    },
  ];
};
